import { useMemo } from 'react';

const PRODUCT_TYPE_ATTR = 'variants.attributes.producttype';

export const useCategoryFacets = (data) => {
  const facets = data?.stream?.searchableAttributes ?? [];

  const filteredFacets = useMemo(() => {
    if (data?.displayProductTypeAttr) {
      return {
        data: [...facets],
      };
    }

    return {
      ...facets,
      data: facets?.filter((x) => x.attributeId !== PRODUCT_TYPE_ATTR),
    };
  }, [facets, data]);

  return { filteredFacets };
};
